import { useCallback, useState } from 'react';

const readStored = <T>(
  key: string,
  fallback: T,
  isValid: (value: unknown) => boolean,
): T => {
  try {
    const raw = localStorage.getItem(key);
    if (raw === null) return fallback;
    const parsed = JSON.parse(raw);
    return isValid(parsed) ? (parsed as T) : fallback;
  } catch {
    return fallback;
  }
};

function useStoredState<T>(
  key: string,
  fallback: T,
  isValid: (value: unknown) => boolean,
): [T, (value: T) => void] {
  const [value, setValue] = useState<T>(() => readStored(key, fallback, isValid));

  const update = useCallback(
    (next: T) => {
      setValue(next);
      try {
        localStorage.setItem(key, JSON.stringify(next));
      } catch {
        // sem armazenamento disponível: a preferência vale só nesta sessão
      }
    },
    [key],
  );

  return [value, update];
}

export default useStoredState;
